import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OrderDetailsShipmentEventInfo from './OrderDetailsShipmentEventInfo';
import OrderDetailsShipmentEventCarton from './OrderDetailsShipmentEventCarton';

import { orderDetailsData } from '../../reducer';

import { FIELD_NA } from '../../constants';

export const OrderDetailsShipmentEvent = ({
  receivedExpand,
  shipmentNumber,
  shipmentsTotal,
  shipmentInfo,
  orderDetailsData
}) => {
  const { productDetails, currencyCode } = orderDetailsData;
  const {
    deliveryNotes: {
      carrierName,
      outboundCartonCount,
      shipmentDetails: {
        actualShippingDate,
        estimatedDeliveryDate,
        shipFromPlantName,
        carrierTrackingNumber,
        billOfLadingNumber
      },
      outboundTransportationTypeCode,
      carrierUrlAddress,
      packs
    },
    productDetails: shipmentProductDetails
  } = shipmentInfo;

  const cartonCount = outboundCartonCount < 1 ? 1 : outboundCartonCount;
  const products = shipmentProductDetails
    ? Object.keys(shipmentProductDetails).map(productCode => ({
        ...productDetails[productCode],
        shipmentProductDetails: shipmentProductDetails[productCode],
        currencyCode: currencyCode
      }))
    : [];

  return (
    <div className='mb5-sm'>
      <OrderDetailsShipmentEventInfo
        shipmentNumber={shipmentNumber}
        shipmentsTotal={shipmentsTotal}
        cartonsTotal={cartonCount}
        carrierUrlAddress={carrierUrlAddress}
        trackingNumber={carrierTrackingNumber || FIELD_NA}
        dateShipped={actualShippingDate}
        estimatedDeliveryDate={estimatedDeliveryDate}
        carrier={carrierName || FIELD_NA}
        shippingMethod={outboundTransportationTypeCode || FIELD_NA}
        shippingOrigin={shipFromPlantName || FIELD_NA}
        billOfLadingNumber={billOfLadingNumber || FIELD_NA}
      />
      {packs.map((pack, i) => (
        <OrderDetailsShipmentEventCarton
          key={`${pack.gs1128CartonId}_${pack.parcelTrackingNumber}_${pack.cartonWeight}`}
          receivedExpand={receivedExpand}
          cartonNumber={i + 1}
          cartonsTotal={packs.length}
          carrierUrlAddress={carrierUrlAddress}
          trackingNumber={pack.parcelTrackingNumber || FIELD_NA}
          products={products}
          pack={pack}
        />
      ))}
    </div>
  );
};

OrderDetailsShipmentEvent.propTypes = {
  receivedExpand: PropTypes.bool.isRequired,
  shipmentNumber: PropTypes.number.isRequired,
  shipmentsTotal: PropTypes.number.isRequired,
  shipmentInfo: PropTypes.any,
  orderDetailsData: PropTypes.object.isRequired
};

OrderDetailsShipmentEvent.defaultProps = {
  shipmentInfo: null
};

const mapStateToProps = state => ({
  orderDetailsData: orderDetailsData(state)
});

const connector = connect(mapStateToProps, {});

export default connector(OrderDetailsShipmentEvent);
